export default __webpack_public_path__ + "static/media/homeCake.1e5aeeb9.png";